<template>
  <Menu as="div" class="relative">
    <MenuButton class="flex items-center justify-center border bg-white shadow-sm hover:bg-gray-100 rounded-md px-3 text-xs h-8">
      <img src="/assets/options.svg" alt="Options" class="mr-2 h-4 w-4" />
      Columns
    </MenuButton>

    <transition
      enter-active-class="transition-opacity duration-100 ease-in-out"
      leave-active-class="transition-opacity duration-100 ease-in-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <MenuItems class="absolute z-50 min-w-32 overflow-hidden rounded-md border bg-white text-popover-foreground shadow-md mt-2 right-0">
        <MenuItem v-for="column in columns.filter(col => col.label !== 'Event')" 
                 :key="column.key"
                 v-slot="{ active }"
        >
          <a 
            :class="[
              'relative flex select-none items-center rounded-sm py-1.5 pl-8 text-xs hover:bg-gray-100 first:pt-3 last:pb-3',
              active ? 'bg-gray-100' : ''
            ]"
            role="menuitemcheckbox"
            tabindex="-1"
            :aria-checked="column.visible"
            :data-state="column.visible ? 'checked' : 'unchecked'"
            @click="$emit('toggle-column', column)"
          >
            <span class="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
              <span v-if="column.visible" data-state="checked">
                <img src="/assets/check-icon.svg" alt="Checked" class="w-4 h-4" />
              </span>
            </span>
            {{ column.label }}
          </a>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'

export default {
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
  },
  props: {
    columns: {
      type: Array,
      required: true
    }
  },
  emits: ['toggle-column']
}
</script> 